import { Navigate, Outlet } from "react-router";
import { useApp } from "../context/AppContext";

interface Props {
  allowedRole: "admin" | "petugas";
}

export default function ProtectedRoute({ allowedRole }: Props) {
  const { currentUser, authLoading, authSlow } = useApp();

  // Tunggu sesi Supabase restore sebelum memutuskan redirect
  if (authLoading) {
    if (authSlow) {
      return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 gap-4">
          <div className="w-8 h-8 border-4 border-[#003580] border-t-transparent rounded-full animate-spin" />
          <p className="text-sm" style={{color:"#003580", fontWeight:600}}>
            Koneksi lambat, mohon tunggu...
          </p>
          <button
            onClick={() => window.location.reload()}
            className="text-xs text-gray-400 underline hover:text-gray-600"
          >
            Refresh halaman
          </button>
        </div>
      );
    }
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (currentUser.role !== allowedRole) {
    // petugas coba akses /admin → arahkan ke /petugas, atau sebaliknya
    return <Navigate to={currentUser.role === "admin" ? "/admin" : "/petugas"} replace />;
  }

  return <Outlet />;
}
